import { render, staticRenderFns } from "./CourseShowPackage.vue?vue&type=template&id=aa6440dc&scoped=true&"
import script from "./CourseShowPackage.vue?vue&type=script&lang=js&"
export * from "./CourseShowPackage.vue?vue&type=script&lang=js&"
import style0 from "./CourseShowPackage.vue?vue&type=style&index=0&id=aa6440dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6440dc",
  null
  
)

export default component.exports